import MeetingTypeListItem from '../../MeetingTypesListItem'
import './style.styl'

const GatedState = ({ gatedOnClick }) =>
  <div className="gated-custom-meeting-times" onClick={gatedOnClick}>
    <div className="helper-text">
      Upgrade your account to access <b>unlimited meeting types</b>. You’ll be able to book Drift Meetings of different lengths so you can only spend your time with the leads that matter most.
    </div>
    <div className="gated-component-wrapper">
      <MeetingTypeListItem key={'gated1'} gated={true} settings={{
        slug: 'sdc',
        duration: 15,
        name: "Short Discovery Call"
      }} />
    </div>
    <div className="gated-component-wrapper">
      <MeetingTypeListItem key={'gated2'} gated={true} settings={{
        slug: 'platinum',
        duration: 60,
        name: "Platinum Customer Kickoff"
      }} />
    </div>
    <div className="PremiumOverlay__Banner">Upgrade</div>
  </div>

export default GatedState



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/MeetingTypesList/GatedState/index.js